import { MatSort, Sort } from '@angular/material/sort';
import { Student } from './../../../model/student/student.model';
import { School } from '../../../model/school.model';
import { GraduationReportResult } from './model/graduation-report-result.model';
import { MsgModel } from './../../common-components/msg/model/msg.model';
import { GraduationReportService } from './service/graduation-report.service';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, timer } from 'rxjs';
import moment from 'moment';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { PagingService } from 'src/app/service/paging.service';

import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { ProgressSpinnerSet, UtilityService } from 'src/app/service/utility.service';
import { ApiFetchExportDataService } from 'src/app/service/api-fetchexportdata.service';
import { Router } from '@angular/router';
import { ChildReportsService } from '../service/child-reports.service';
import { RegionDataService } from 'src/app/component/common-components/service/region-data.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ThemePalette } from '@angular/material/core';
import { ChosenRegion, ChosenSchoolDistrict } from '../counts/model/student-eligibility-count';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { DistrictDataService } from '../../common-components/service/district-data.service';

@Component({
    selector: 'app-graduation-report',
    templateUrl: './graduation-report.component.html',
    styleUrls: ['./graduation-report.component.scss']
})
export class GraduationReportComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode!: SchoolDropdownComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    allRegions: Region[] = [];
    allDistricts: SchoolDistrict[] = [];
    lstSelectedRegion: Region[] = [];
    lstSelecteddistricts: SchoolDistrict[] = [];
    lstSelectedschools: School[] = [];
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    isExporting: boolean = false;
    hasExports: boolean = false;

    // Component variables
    resetField: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;
    progressSubscription: Subscription;
    progressInterval: number = 500;

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    lstGraduationReportResponse: GraduationReportResult[];
    strExportFileName = 'Graduation_Report';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    // Table display
    baseDisplayedColumns: string[] = ['MSD_NUMBER', 'SSID', 'PERSON.LAST_NAME', 'STUDENT_TERMINATION_STATUS_TYPE', 'STUDENT_TERMINATION_STATUS_DATE'];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSources: MatTableDataSource<Student>[] = [];

    // Results
    results: GraduationReportResult[] = [];
    displayName: string = '';

    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;
    isLoadingResults: boolean = false;
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    settings: any = {
        '/reports/graduation-report': {
            TITLE: 'Graduation Report',
            EXPORTFILENAME: 'Graduation_Report',
            API: undefined,
            SCHOOL_YEAR: true,
            QUESTION_HELP_TEXT_ID: 248,
            COLUMN_HEADERS: ['School Year', 'District', 'School', 'MSD Number', 'SSID', 'Name', 'Completion Type', 'Completion Date'],
            COLUMN_WIDTHS: [52, 52, 52, 82, 82, 52, 52, 52],
            COLUMNS: [
                'SCHOOL_YEAR',
                'DISTRICT',
                'SCHOOL',
                'MSD_NUMBER',
                'SSID',
                'PERSON.LAST_NAME',
                'STUDENT_TERMINATION_STATUS_TYPE',
                'STUDENT_TERMINATION_STATUS_DATE'
            ]
        }
    };
    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private graduationReportService: GraduationReportService,
        private apiMsinExportsService: ApiExportsService,
        private urlProvider: UrlProviderService,
        private utilityService: UtilityService,
        private apiFetchExportDataService: ApiFetchExportDataService,
        router: Router,
        private childReportsService: ChildReportsService,
        private regionDataService: RegionDataService,
        private districtDataService: DistrictDataService
    ) {
        console.log('now connecting:');
        console.log(router.url);
        this.connectAPIs(childReportsService);
        this.selectSettings(router.url);
        console.log('currentSetting:');
        console.log(this.currentSetting);
        console.log(this.settings);
    }

    ngOnInit(): void {
        this.regionDataService.getAll().subscribe({
            next: (data: any) => {
                this.allRegions = data;
            },
            error: (error: any) => {
                console.error('Error fetching regions:', error);
            }
        });

        this.districtDataService.getAll().subscribe({
            next: (data: any) => {
                this.allDistricts = data;
                console.log('got all districts as: ');
                console.log(this.allDistricts);
            },
            error: (error: any) => {
                console.error('Error fetching districts:', error);
            }
        });
    }

    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};

            this.graduationReportService
                .search(
                    this.toNumberArray(this.chosenRegions),
                    this.toNumberArray(this.chosenCounties),
                    this.toNumberArray(this.chosenSchoolDistricts),
                    this.toNumberArray(this.chosenSchools),
                    this.selectedPerformancePeriod
                )
                .subscribe({
                    next: (res) => {
                        if (res.regions) {
                            this.results = res.regions.sort((n1: GraduationReportResult, n2: GraduationReportResult) => (n1.CODE! > n2.CODE! ? 1 : -1));

                            this.displayedColumns = ['SCHOOL.COUNTy.COUNTY_NAME', 'SCHOOL.SCHOOL_DISTRICT.DISTRICTS', 'SCHOOL.NAME'];
                            this.displayedColumns = this.displayedColumns.concat(this.baseDisplayedColumns);

                            this.displayName = this.results.length > 1 ? 'Regions' : 'Region';
                        } else if (res.counties) {
                            this.results = res.counties.sort((n1: GraduationReportResult, n2: GraduationReportResult) =>
                                n1.COUNTY_NAME! > n2.COUNTY_NAME! ? 1 : -1
                            );

                            this.displayedColumns = ['SCHOOL.SCHOOL_DISTRICT.DISTRICTS', 'SCHOOL.NAME'];
                            this.displayedColumns = this.displayedColumns.concat(this.baseDisplayedColumns);

                            this.displayName = this.results.length > 1 ? 'Counties' : 'County';
                        } else if (res.schoolDistricts) {
                            this.results = res.schoolDistricts.sort((n1: GraduationReportResult, n2: GraduationReportResult) =>
                                n1.DISTRICTS! > n2.DISTRICTS! ? 1 : -1
                            );

                            this.displayedColumns = ['SCHOOL.NAME'];
                            this.displayedColumns = this.displayedColumns.concat(this.baseDisplayedColumns);

                            this.displayName = this.results.length > 1 ? 'School Districts' : 'School District';
                        } else if (res.schools) {
                            this.results = res.schools.sort((n1: GraduationReportResult, n2: GraduationReportResult) =>
                                n1.SCHOOL_NAME! > n2.SCHOOL_NAME! ? 1 : -1
                            );

                            this.displayedColumns = ['SCHOOL.NAME'];
                            this.displayedColumns = this.displayedColumns.concat(this.baseDisplayedColumns);

                            this.displayName = this.results.length > 1 ? 'Schools' : 'School';
                        } else if (res.msg) {
                            this.results = [];
                            this.msg = res.msg;
                        } else {
                            this.results = [];
                            this.msg = { SUCCESS: false, MSG: 'Error retrieving Graduation Report.' };
                        }
                    },
                    error: (err) => {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Graduation Report.' };
                    },
                    complete: () => {
                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();

                        // Display current performance period
                        this.currentPerformancePeriod = this.selectedPerformancePeriod;

                        // Expand all
                        this.expandAll(this.results);

                        // Display results
                        this.isLoading = false;
                    }
                });
        }
    }

    generateDisplayColumns(schoolYear: string, prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];

        displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        return displayedColumns;
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID);
        payload.performancePeriod = this.selectedPerformancePeriod;

        return payload;
    }

    connectAPIs(childReportsService: ChildReportsService) {
        this.settings['/reports/graduation-report'].API = function (payload: any) {
            return childReportsService.getGraduationReport(payload);
        };
    }

    selectSettings(url: string) {
        this.currentSetting = this.settings[url];
    }

    updateDataSource() {
        this.tableDataSources = [];

        setTimeout(() => {
            this.results.forEach((result, index) => {
                // Data
                let dataSource = new MatTableDataSource<Student>();
                dataSource.data = result.STUDENTS!;

                // Paginator
                dataSource.paginator = this.paginators.toArray()[index];

                // Sort
                dataSource.sort = this.sorts.toArray()[index];
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
                dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                // Filter
                dataSource.filterPredicate = (data: any, filter) => {
                    const dataStr = JSON.stringify(data).toLowerCase();
                    return dataStr.indexOf(filter) != -1;
                };

                this.tableDataSources.push(dataSource);
            });
        });
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && this.selectedPerformancePeriod) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];
        this.msg = {};
    }

    hasChild = (_: number, node: GraduationReportResult) => !!node.STUDENTS && node.STUDENTS.length > 0;

    expandAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = true;
        });
    }

    collapseAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = false;
        });
    }

    toggleShow(obj: any) {
        obj.SHOW = !obj.SHOW;
    }

    announceSortChange(sortState: Sort) {}

    isQadExpired(d: string) {
        if (moment(d).isValid()) {
            let qad = new Date(moment(d).format('LL'));
            let expiredDay = new Date(qad.getFullYear() + 3, qad.getMonth(), qad.getDate());
            const today = new Date(moment().format('LL'));

            if (expiredDay < today) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    fnInitializeProgressSpinner(iCount: number, isPdf: boolean) {
        this.progressMax = iCount;
        let numResults: ProgressSpinnerSet = {
            progressMax: this.progressMax,
            progressCurrentValue: this.progressCurrentValue,
            progressValue: this.progressValue,
            progressSpeed: this.progressSpeed,
            isPdf: isPdf
        };
        this.utilityService.fnPrepProgressSpinner(numResults);
        this.progressMax = numResults.progressMax;
        this.progressCurrentValue = numResults.progressCurrentValue;
        this.progressValue = numResults.progressValue;
        this.progressSpeed = numResults.progressSpeed;
    }

    downloadXLS() {
        console.log('now downloading xls data');
        //this.isExporting = true;
        //this.isLoadingResults = true;
        console.log('now download xls');
        console.log(this.tableDataSources[0].data);

        setTimeout(() => {
            this.downloadXLSCore(false);
        }, 100);
    }

    downloadXLSCore(bViaPost: boolean) {
        console.log('now downstreaming XLS file :');

        this.lstGraduationReportResponse = this.tableDataSources[0].data;
        console.log('with rows:');
        console.log(this.lstGraduationReportResponse);
        this.isExporting = true;
        this.progressMax = this.lstGraduationReportResponse.length;
        console.log('set progressMax at:');
        console.log(this.progressMax);
        this.progressValue = 10;
        this.progressCurrentValue = 10;
        this.progressValue = (1 / this.progressMax) * 100;

        console.log('initial progressValue=');
        console.log(this.progressValue);
        console.log('creating school from: ');
        console.log(this.appSchoolsCode?.selectedSchoolIds);
        console.log('creating school districts from: ');
        console.log(this.appSchoolDistrictCode?.selectedSchoolDistrictIds);
        console.log('school year:');
        console.log(this.selectedPerformancePeriod);
        this.lstSelectedRegion = this.appRegionCode?.selectedRegionIds?.map((num: number) => this.utilityService.CreateRegionFromNumber(num));
        this.lstSelecteddistricts = this.appSchoolDistrictCode?.selectedSchoolDistrictIds?.map((num: number) =>
            this.utilityService.CreateSchoolDistrictFromNumber(num)
        );
        this.lstSelectedschools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
        this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();
        this.strExportFileName = this.currentSetting?.EXPORTFILENAME ?? '';
        let strTemplateName = this.strExportFileName;
        this.searchParm.strExportType = 'XLS';

        try {
            this.lstGraduationReportResponse = this.tableDataSources[0].data;

            this.searchParm = this.generatePayload();
            this.searchParm.lstSelectedRegion = JSON.stringify(this.lstSelectedRegion);
            this.searchParm.chosenRegions = this.allRegions.find((region) => region.CODE === this.appRegionCode?.selectedRegionIds[0].toString()); // this.appRegionCode?.selectedRegionIds?.map((num:number) => this.utilityService.CreateRegionFromNumber(num));
            this.searchParm.chosenCounties = this.appCountyCode?.selectedCountyIds.map((num: number) => this.utilityService.CreateCountyFromNumber(num));
            this.searchParm.chosenSchools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
            this.searchParm.chosenSchoolDistricts = this.allDistricts.find(
                (district) => district.DISTRICTS === this.appSchoolDistrictCode?.selectedSchoolDistrictName?.toString()
            ); //this.lstSelecteddistricts;
            this.searchParm.schoolYear = this.selectedPerformancePeriod;
            this.searchParm.schools = this.lstGraduationReportResponse;
            this.searchParm.Template_Name = strTemplateName;

            this.searchParm.strFileName = strTemplateName;
            this.searchParm.fileNameLabel = this.fileNameLabel;
            this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();

            this.searchParm.columns = this.currentSetting?.COLUMNS;
            this.searchParm.columnHeaders = this.currentSetting?.COLUMN_HEADERS ?? 0;
            this.searchParm.columnWidths = this.currentSetting?.COLUMN_WIDTHS ?? 0;
            this.searchParm.file_name_label = this.currentSetting?.TITLE ?? '';
            this.searchParm.reportType = 0;
            this.searchParm.strExportType = 'XLS';

            setTimeout(() => {
                console.log('passing searchParm');
                console.log(this.searchParm);

                const progressInterval = setInterval(() => {
                    if (this.progressCurrentValue <= this.progressSpinnerMax) {
                        // this corresponds to 100% of the spinner rotation
                        this.progressCurrentValue += 1;
                        this.progressValue = (this.progressCurrentValue / this.progressMax) * 100;
                        /* console.log("cur value is: ")
                            console.log(this.progressValue)
                            console.log(this.progressCurrentValue)*/
                    } else {
                        this.isExporting = false;
                        clearInterval(progressInterval);
                    }
                }, this.progressSpeed); // spinner speed, smaller value=faster

                let chosenRegions: number[] = this.chosenRegions.map((item) => item.ID ?? 0);
                let chosenCounties: number[] = this.chosenCounties.map((item) => item.ID ?? 0);
                let chosenSchoolDistricts: number[] = this.chosenSchoolDistricts.map((item) => item.ID ?? 0);
                let chosenSchools: number[] = this.chosenSchools.map((item) => item.ID ?? 0);

                /*var params = {
	                        chosenRegions: chosenRegions,
	                        chosenCounties: chosenCounties,
	                        chosenSchoolDistricts: chosenSchoolDistricts,
	                        chosenSchools: chosenSchools,
	                        performancePeriod: this.searchParm.schoolYear,
	                        expiredEligibility: this.expiredEligibility,
	                        expiredQAD: this.expiredQAD,
	                        grades: this.grades,
	                        partyServices: this.partyServices,
	                        enrollmentPeriods: this.enrollmentPeriods
	                  
                        }    */

                this.searchParm.chosenRegions = chosenRegions;
                this.searchParm.chosenCounties = chosenCounties;
                this.searchParm.chosenSchoolDistricts = chosenSchoolDistricts;
                this.searchParm.chosenSchools = chosenSchools;
                this.searchParm.performancePeriod = this.searchParm.schoolYear;

                this.apiMsinExportsService.getGraduationPost(this.searchParm);
            });
        } catch (Err) {
            console.log('Error running filestream XLS export: ');
            console.log(Err);
            this.isExporting = false; // hide spinner
        }
    }

    downloadPDF() {
        this.downloadPdfCore(false);
    }

    downloadPdfCore(bRegional: boolean) {
        console.log('now downstreaming PDF file');

        this.lstGraduationReportResponse = this.tableDataSources[0].data;
        console.log('with rows:');
        console.log(this.lstGraduationReportResponse);
        this.isExporting = true;
        this.progressMax = this.lstGraduationReportResponse.length;
        console.log('set progressMax at:');
        console.log(this.progressMax);
        console.log('schoolyears passed:');
        console.log(this.selectedSchoolYear);
        console.log(this.selectedPerformancePeriod);
        this.progressValue = 10;
        this.progressCurrentValue = 10;
        this.progressValue = (1 / this.progressMax) * 100;

        console.log('initial progressValue=');
        console.log(this.progressValue);
        console.log('creating school from: ');
        console.log(this.appSchoolsCode?.selectedSchoolIds);
        console.log('creating school districts from: ');
        console.log(this.appSchoolDistrictCode?.selectedSchoolDistrictIds);

        this.lstSelectedRegion = this.appRegionCode?.selectedRegionIds?.map((num: number) => this.utilityService.CreateRegionFromNumber(num));
        this.lstSelecteddistricts = this.appSchoolDistrictCode?.selectedSchoolDistrictIds?.map((num: number) =>
            this.utilityService.CreateSchoolDistrictFromNumber(num)
        );
        this.lstSelectedschools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
        this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();
        this.strExportFileName = this.currentSetting?.EXPORTFILENAME ?? '';
        let strTemplateName = this.strExportFileName;
        this.searchParm.strExportType = 'PDF';

        try {
            this.lstGraduationReportResponse = this.tableDataSources[0].data;

            this.searchParm = this.generatePayload();
            this.searchParm.lstSelectedRegion = JSON.stringify(this.lstSelectedRegion);
            this.searchParm.chosenRegions = this.allRegions.find((region) => region.CODE === this.appRegionCode?.selectedRegionIds[0].toString()); // this.appRegionCode?.selectedRegionIds?.map((num:number) => this.utilityService.CreateRegionFromNumber(num));
            this.searchParm.chosenCounties = this.appCountyCode?.selectedCountyIds.map((num: number) => this.utilityService.CreateCountyFromNumber(num));
            this.searchParm.chosenSchools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
            this.searchParm.chosenSchoolDistricts = this.allDistricts.find(
                (district) => district.DISTRICTS === this.appSchoolDistrictCode?.selectedSchoolDistrictName?.toString()
            ); //this.lstSelecteddistricts;
            this.searchParm.schoolYear = this.selectedPerformancePeriod;
            this.searchParm.schools = this.lstGraduationReportResponse;
            this.searchParm.Template_Name = strTemplateName;

            this.searchParm.strFileName = strTemplateName;
            this.searchParm.fileNameLabel = this.fileNameLabel;
            this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();

            this.searchParm.columns = this.currentSetting?.COLUMNS;
            this.searchParm.columnHeaders = this.currentSetting?.COLUMN_HEADERS ?? 0;
            this.searchParm.columnWidths = this.currentSetting?.COLUMN_WIDTHS ?? 0;
            this.searchParm.file_name_label = this.currentSetting?.TITLE ?? '';
            this.searchParm.reportType = 1;
            this.searchParm.strExportType = 'PDF';

            setTimeout(() => {
                console.log('passing searchParm');
                console.log(this.searchParm);
                this.isExporting = true;
                const progressInterval = setInterval(() => {
                    if (this.progressCurrentValue <= this.progressSpinnerMax) {
                        // this corresponds to 100% of the spinner rotation
                        this.progressCurrentValue += 1;
                        this.progressValue = (this.progressCurrentValue / this.progressMax) * 100;
                        /* console.log("cur value is: ")
                                console.log(this.progressValue)
                                console.log(this.progressCurrentValue)*/
                    } else {
                        this.isExporting = false;
                        clearInterval(progressInterval);
                    }
                }, this.progressSpeed); // spinner speed, smaller value=faster

                let chosenRegions: number[] = this.chosenRegions.map((item) => item.ID ?? 0);
                let chosenCounties: number[] = this.chosenCounties.map((item) => item.ID ?? 0);
                let chosenSchoolDistricts: number[] = this.chosenSchoolDistricts.map((item) => item.ID ?? 0);
                let chosenSchools: number[] = this.chosenSchools.map((item) => item.ID ?? 0);

                var params = {
                    chosenRegions: chosenRegions,
                    chosenCounties: chosenCounties,
                    chosenSchoolDistricts: chosenSchoolDistricts,
                    chosenSchools: chosenSchools,
                    performancePeriod: this.searchParm.schoolYear
                    /*expiredEligibility: this.expiredEligibility,
	                        expiredQAD: this.expiredQAD,
	                        grades: this.grades,
	                        partyServices: this.partyServices,
	                        enrollmentPeriods: this.enrollmentPeriods*/
                };
                this.searchParm.chosenRegions = params.chosenRegions;
                this.searchParm.chosenCounties = params.chosenCounties;
                this.searchParm.chosenSchools = params.chosenSchools;
                this.searchParm.performancePeriod = params.performancePeriod;
                console.log('now calling http post with params:');
                console.log(params);
                this.apiMsinExportsService.getGraduationPost(this.searchParm);
            });
        } catch (Err) {
            console.log('Error running filestream PDF export: ');
            console.log(Err);
            //console.log("hid spinner2")
            this.isExporting = false;
        }
    }
}
